import React from 'react';
import { AlertCircle, RefreshCw, Home } from 'lucide-react';
import { Link } from 'react-router-dom';

const DashboardErrorFallback = ({ error, isMobile = false }) => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className={`min-h-screen bg-stone-50 flex items-center justify-center p-4 ${isMobile ? 'mobile-error' : 'desktop-error'}`}>
      <div className="max-w-md w-full bg-white rounded-xl shadow-sm border border-stone-200 p-6 text-center">
        <div className="mb-4">
          <AlertCircle className="w-12 h-12 text-amber-500 mx-auto mb-3" />
          <h2 className="text-lg font-semibold text-slate-900 mb-2">
            Dashboard Temporarily Unavailable
          </h2>
          <p className="text-sm text-stone-600 mb-4">
            We're having trouble loading your dashboard. This is usually temporary.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleRefresh}
            className="w-full bg-primary-500 text-white px-4 py-2 rounded-lg font-medium hover:bg-primary-600 transition-colors flex items-center justify-center gap-2"
          >
            <RefreshCw className="w-4 h-4" />
            Refresh Dashboard
          </button>
          
          <Link
            to="/"
            className="w-full bg-stone-100 text-stone-700 px-4 py-2 rounded-lg font-medium hover:bg-stone-200 transition-colors flex items-center justify-center gap-2 no-underline"
          >
            <Home className="w-4 h-4" />
            Go to Home
          </Link>
        </div>

        {error && (
          <details className="mt-4 text-left">
            <summary className="text-xs text-stone-500 cursor-pointer hover:text-stone-700">
              Technical Details
            </summary>
            <pre className="text-xs text-red-600 mt-2 p-2 bg-red-50 rounded border overflow-auto">
              {error.message || 'Unknown error occurred'}
            </pre>
          </details>
        )}

        <p className="text-xs text-stone-400 mt-4">
          If this persists, please contact support
        </p>
      </div>
    </div>
  );
};

export default DashboardErrorFallback; 